import Socket from "../../../services/WebsocketService";
import ManualApprovalLogic from "./manualApprovalLogic";
import { useState } from "react";

const MemeApproval = ({
    getSettings,
    updateUserSettings,
    approveOrDenyMeme,
    deletePendingMeme,
    pushPendingMeme,
    currentMeme,
    browserSourceIsActive,
    applicationDisplayLocation,
    title,
    isDashboard,
}) => {
    const [remotelyApprovedby, setRemotelyApprovedby] = useState(null);
    const [isApiCallInProgress, setIsApiCallInProgress] = useState(false);
    const [isBlueToggleClickable, setIsBlueToggleClickable] = useState(true);

    // logic on incoming msg
    const messageHandler = async (event) => {
        const eventData = JSON.parse(event.data);
        const memeElement = eventData.data;

        if (eventData.message === "PENDING_APPROVAL")
            pushPendingMeme(memeElement);

        // We want to make sure we dont see memes rapidly disappear if
        // they are being approved quickly because they all had a setTimeout
        // Instead if we dont have a timer running, we will remove them immediately.
        if (eventData.message === "REMOVE_PENDING_APPROVAL_MEME") {
            if (!remotelyApprovedby && !isApiCallInProgress) {
                deletePendingMeme(memeElement);

                setRemotelyApprovedby(memeElement);

                setTimeout(() => setRemotelyApprovedby(null), 3000);
            } else {
                deletePendingMeme(memeElement);
            }
        }
    };

    // Establish websocket connection
    const queryStringParams = "broadcasterManagementConnection=true";
    Socket.useWebsocketService({ queryStringParams, messageHandler });

    return (
        <ManualApprovalLogic
            getSettings={getSettings}
            updateUserSettings={updateUserSettings}
            approveOrDenyMeme={approveOrDenyMeme}
            currentMeme={currentMeme}
            browserSourceIsActive={browserSourceIsActive}
            remotelyApprovedby={remotelyApprovedby}
            applicationDisplayLocation={applicationDisplayLocation}
            setIsApiCallInProgress={setIsApiCallInProgress}
            isApiCallInProgress={isApiCallInProgress}
            isBlueToggleClickable={isBlueToggleClickable}
            setIsBlueToggleClickable={setIsBlueToggleClickable}
            title={title}
            isDashboard={isDashboard}
        />
    );
};

export default MemeApproval;
